// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"loading_loadingIcon_2ZCWB"};